module.exports = __webpack_public_path__ + "img/glc-suv.1f7e9c5c.jpg";